import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { API } from "@/lib/api";

/**
 * Simple modal that shows the newly-issued (or manually re-opened) pass's
 * QR code + a full-screen "open" link. Parent controls open/close via
 * `pass` prop (null = closed).
 */
export function QrModal({ pass, onClose }) {
  if (!pass) return null;
  const qrUrl = `${API}/me/guest-passes/${pass.id}/qr.png`;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="guest-pass-qr-modal">
        <DialogHeader><DialogTitle>Guest pass — {pass.guest_name}</DialogTitle></DialogHeader>
        <div className="space-y-3 text-center">
          <div className="rounded-lg bg-white p-4 inline-block mx-auto">
            <img src={qrUrl} alt="QR code" className="mx-auto"
                 style={{ maxWidth: "260px", height: "auto" }}
                 data-testid="guest-pass-qr-image" />
          </div>
          <div className="text-xs text-zinc-400">
            Share this code with your guest. Security scans it at the gate to validate the pass.
          </div>
          <div className="text-xs text-zinc-500">
            Plate <span className="font-mono">{pass.plate}</span>{" · "}
            Valid until {new Date(pass.valid_until).toLocaleString()}
          </div>
          <Button onClick={() => window.open(qrUrl, "_blank")}
                  variant="outline"
                  className="rounded-full border-white/10"
                  data-testid="guest-pass-qr-open">
            Open QR full-size
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
